import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PowerUserActions } from './actions/power-user.actions';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [ PowerUserActions ]
})
export class PowerUserModule { }
